import * as React from 'react';

import { SearchResultsTooltip } from '../SearchResultsTooltip';
import { Dropdown, FilterButton, Outside } from './components';

interface IDropdownFilterProps {
  open: boolean;
  label: string;
  openTooltip: boolean;
  onClose(): void;
  onClick(): void;
  dataName?: string;
  dropdownContent: React.ReactNode;
  count?: number;
}

export const DropdownFilter: React.FC<IDropdownFilterProps> = ({
  open,
  openTooltip,
  label,
  onClose,
  onClick,
  dataName,
  dropdownContent,
  count,
}) => {
  const filterButtonRef = React.useRef<HTMLButtonElement>(null);
  const popupContentRef = React.useRef<HTMLDivElement>(null);

  return (
    <Outside onOutside={onClose} active={open} insideRefs={[popupContentRef]}>
      <div data-name={dataName}>
        <SearchResultsTooltip open={!open && openTooltip} placement="bottom-start">
          <FilterButton onClick={onClick} isActive={open} ref={filterButtonRef} count={count}>
            {label}
          </FilterButton>
        </SearchResultsTooltip>
        <Dropdown anchorRef={filterButtonRef} opened={open}>
          <div ref={popupContentRef} data-name={`${dataName}Dropdown`}>
            {dropdownContent}
          </div>
        </Dropdown>
      </div>
    </Outside>
  );
};
